import { render, staticRenderFns } from "./ProfilePage.vue?vue&type=template&id=2ea3b3a0"
import script from "./ProfilePage.js?vue&type=script&lang=js&external"
export * from "./ProfilePage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports